export function round(value, decimals) {
    return Number(Math.round(value + 'e' + decimals) + 'e-' + decimals)
}

export function displayNumber(value, decimals) {
    return comma(round(value, decimals), decimals)
}

export function comma(val, dec) {
    if (!val) val = 0
    if (val.toString().indexOf(',') > -1) return val
    if (dec) val = parseFloat(val).toFixed(dec)
    val += ''

    let x = val.split('.')
    let x1 = x[0]
    let x2 = x.length > 1 ? '.' + x[1] : ''
    let rgx = /(\d+)(\d{3})/

    while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2')
    }

    return x1 + x2
}
